'use client';

import {Suspense, useEffect} from 'react';
import {useSearchParams} from 'next/navigation';
import {LoginForm} from 'iq-auth/components/login_form';
import {AuthError} from 'iq-auth/components/auth_error';
import {useAuth} from 'iq-auth';
import {enqueuePostAuthAction} from 'iq-auth/post_auth_actions';
import {redeemAccessCodeAction} from 'iq-auth/post_auth_actions/redeem_access_code';

export function LoginPage() {
  const {user, isReady} = useAuth();
  const params = useSearchParams();
  const initialEmail = params.get('e') ?? undefined;
  const next = params.get('next') ?? undefined;
  const accessCode = params.get('c') ?? undefined;

  // A logged-in user has nothing to log into.
  useEffect(() => {
    if (isReady && user.loggedIn) window.location.href = next || '/dashboard';
  }, [isReady, user.loggedIn, next]);

  // Carry a `?c=` access code (e.g. an existing user redeeming via the activation
  // link) through to redemption, which runs post-auth for password and OAuth alike.
  useEffect(() => {
    if (accessCode) {
      enqueuePostAuthAction(redeemAccessCodeAction, {code: accessCode, email: initialEmail});
    }
  }, [accessCode, initialEmail]);

  function goToSignup() {
    const query = new URLSearchParams();
    if (initialEmail) query.set('e', initialEmail);
    if (next) query.set('next', next);
    if (accessCode) query.set('c', accessCode);
    const qs = query.toString();
    window.location.href = `/signup${qs ? `?${qs}` : ''}`;
  }

  return (
    <div className='flex flex-col gap-6'>
      <Suspense>
        <AuthError variant='light' />
      </Suspense>
      <LoginForm
        initialEmail={initialEmail}
        next={next}
        onSuccess={() => {
          window.location.href = next || '/dashboard';
        }}
        onSwitchToSignup={goToSignup}
      />
    </div>
  );
}
